import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    defaultLabel: String,
    specialLabel: String,
    defaultCaption: String,
    specialCaption: String,
  }

  update(event) {
    const isSpecial = event.target.value === "special_rate"
    const label = this.element.querySelector('label[for="discount_savings"]')
    const caption = label?.parentElement?.querySelector(".text-gray-500")
    if (label) {
      label.textContent = isSpecial ? this.specialLabelValue : this.defaultLabelValue
    }
    if (caption) {
      caption.textContent = isSpecial ? this.specialCaptionValue : this.defaultCaptionValue
    }
  }
}
